export const hasPermission = (roles: string[], perfil?: string): boolean => {
  if (!perfil) return false;
  if (roles?.length === 0) return true;
  return !!roles?.find((role) => {
    return perfil === role;
  });
};
